module.exports = __webpack_public_path__ + "img/ic-delivery.0f23a53f.svg";